module.exports = __webpack_public_path__ + "static/img/dataLeakInstallForWin_pic3.0b3ca05.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/dataLeakInstallForWin/dataLeakInstallForWin_pic3.png
// module id = 495
// module chunks = 1